import { FundOutlined } from '@ant-design/icons';
import { AButton, AModal } from '../../../../../components';
import { IFinancial } from '../../../../../shared/interfaces';
import MovementsFinancialsReport from '../../../../../shared/reports/Financial/MovementsFinancial';

interface IReportMovement {
  data: IFinancial[];
  totalPaid: number;
  totalReceived: number;
}

interface IMovementsFinancialPrintProps {
  open: boolean;
  close: () => void;
  report: IReportMovement;
}

const MovementsFinancialPrint: React.FC<IMovementsFinancialPrintProps> = ({
  open,
  close,
  report,
}) => {
  return (
    <AModal
      open={open}
      close={close}
      footer={[
        <AButton key="close" type="default" onClick={close}>
          Fechar
        </AButton>,
      ]}
      width={900}
      title={
        <>
          <FundOutlined /> Movimentação
        </>
      }
    >
      <MovementsFinancialsReport report={report} />
    </AModal>
  );
};

export default MovementsFinancialPrint;
